import { Component, OnInit } from '@angular/core';
import { OrientationService } from '../../../../services/orientation.service';
import { MessageServerService } from '../../../../services/hub-services/message-server/message-server.service';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { OrientationPatientSearchItem } from '../../../../model/orientation/orientation-patient-search-item';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-tool-orientation-patient-caller',
  templateUrl: './tool-orientation-patient-caller.component.html',
  styleUrls: ['./tool-orientation-patient-caller.component.css']
})
export class ToolOrientationPatientCallerComponent implements OnInit {

  loading: boolean;
  orientationPatientSearchItems: OrientationPatientSearchItem[];
  lastCall: OrientationPatientSearchItem;
  workstationSelected: string;
  workstations: string[] = [
    'Puesto 1',
    'Puesto 2',
    'Puesto 3',
    'Puesto 4',
    'Puesto 5',
    'Puesto 6',
    'Puesto 7',
    'Puesto 8',
    'Puesto 9',
    'Puesto 10',
    'Puesto 11',
    'Puesto 12',
    'Puesto 13',
    'Puesto 14',
    'Puesto 15',
  ];

  constructor( private orientationService: OrientationService,
               private authService: AuthService,
               private notificationToastService: NotificationToastService ) {}

  async ngOnInit() {
    if ( localStorage.getItem('lastCall') ) {
      this.lastCall = JSON.parse(localStorage.getItem('lastCall'));
    }

    if ( localStorage.getItem('workstation') ) {
      this.workstationSelected =  localStorage.getItem('workstation');
    }

    await this.loadOrientationPatientSearchItems();
  }

  async loadOrientationPatientSearchItems() {
    try {
      this.loading = true;
      this.orientationPatientSearchItems = await this.orientationService
        .getOrientationPatientSearchItem(this.authService.getSectorId());
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Orientador');
    }
    finally {
      this.loading = false;
    }
  }

  async callPatient(orientationPatientSearchItem: OrientationPatientSearchItem) {
    if (this.workstationSelected ) {
      try {
        orientationPatientSearchItem.LoadingAction = true;
        await this.orientationService
                .callOrientationPatient(orientationPatientSearchItem.Id,
                    this.authService.getSectorId(), this.workstationSelected);
        orientationPatientSearchItem.Called = true;
        this.lastCall = orientationPatientSearchItem;
        this.lastCall.LoadingAction = false;
        localStorage.setItem('lastCall', JSON.stringify(this.lastCall));
        localStorage.setItem('workstation', this.workstationSelected);
        const index = this.orientationPatientSearchItems.findIndex(o => o.Id === orientationPatientSearchItem.Id);
        if ( index > -1) {
          this.orientationPatientSearchItems.splice(index, 1);
        }
      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Orientador');
      } finally {
        orientationPatientSearchItem.LoadingAction = false;
      }
    }
  }
}
